import { render } from "./Antragstellerregel.pug?vue&type=template&id=52dbb427&lang=pug"
import script from "./Antragstellerregel.js?vue&type=script&lang=js"
export * from "./Antragstellerregel.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__